<script lang="ts" setup>
import { storeToRefs } from "pinia";

import Transaction from "@/classes/Transaction.ts";

import { remove } from "@/repositories/transactions.ts";
import { confirm } from "@/functions/confirm.ts";
import { onEdit } from "@/functions/transactions.ts";

import ConfirmDelete from "@/components/Confirmation/ConfirmDelete.vue";
import ListItem from "@/components/ListView/ListItem.vue";

import { useTransactions } from "@/stores/transactions.ts";

const transactions = useTransactions();

const { all } = storeToRefs(transactions);

const onRemove = async (tx: Transaction) => {
  confirm(
    ConfirmDelete,
    async () => {
      if (await remove(tx)) {
        transactions.forget(tx);
      }
    },
    { title: `Wil je "${tx.name}: ${tx.description}" verwijderen?` },
  );
};
</script>

<template>
  <div class="mt-8 flow-root overflow-hidden">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <table class="w-full text-left divide-y divide-gray-300">
        <thead class="bg-white">
          <tr class="text-sm text-gray-900">
            <th
              class="relative isolate py-3.5 px-3 text-xs text-gray-500 text-left font-medium uppercase"
              scope="col"
            >
              Datum
            </th>
            <th
              class="hidden px-3 py-3.5 text-xs text-gray-500 text-left font-medium uppercase sm:table-cell"
              scope="col"
            >
              Naam
            </th>
            <th
              class="hidden px-3 py-3.5 text-xs text-gray-500 text-left font-medium uppercase md:table-cell"
              scope="col"
            >
              Omschrijving
            </th>
            <th
              class="px-3 py-3.5 text-xs text-gray-500 text-left font-medium uppercase"
              scope="col"
            >
              Bedrag
            </th>
            <th class="px-3 py-3.5 text-gray-500 text-left font-medium uppercase" scope="col">
              Saldo
            </th>
            <th class="relative py-3.5 text-xs pl-3" scope="col">
              <span class="sr-only">Edit</span>
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-200 bg-white">
          <ListItem
            v-for="item in all"
            :key="item.id!"
            :item="item"
            @edit="onEdit(item.id!, item.type)"
            @remove="onRemove(item as Transaction)"
          ></ListItem>
        </tbody>
      </table>
    </div>
  </div>
</template>
